<script setup>
import {ref} from "vue";
import createTenantPost from "./components/createTenantPost/index.vue"
import {addClubIgnore} from "@/api/club/ignoreTenant.js";
import router from "@/router/index.js";
import {addStoreIgnore} from "@/api/store/ignoreTenant.js";

// 加载状态
const loading = ref(false)
/*基本信息相关*/
// 基本信息表单
const ruleForm = ref({
  storeLogo: null,
  name: null,
  nameEn: "Coming Soon ...",
  storeAddress: {
    provinceCode: null,
    cityCode: null,
    districtCode: null,
    addressDetail: null,
    addressDetailEn: null
  },
  // 营业时间
  operatingHours: [{
    operatingTime: [],
    weekdayOpen: null,
    weekdayClose: null,
    operatingStart: null,
    operatingEnd: null
  }],
  nonSelfOperatedLink: null,
  isSelfOperated: true,
  certificationType: null,
  partnerStores: [],
  referralOfficer: {
    name: null,
    phone: null
  },
  bikeStoreName: null,
  bikeStoreId: null,
  // 负责人信息
  contactName: null,
  phone: null,
  contactEmail: null,
  recipientInfo: {
    recipientName: null,
    recipientPhone: null,
    recipientAddress: {
      provinceCode: null,
      cityCode: null,
      districtCode: null,
      addressDetail: null
    }
  },
  tagIdList: [],
  featureTagIdList: [],
  assistsOperation: true,
  storeCoverImage: null,
  photoList: [],
  storeDiscoverCoverImage: null
})
// 处理表单提交新建俱乐部
const handleCreateTenantClub = async () => {
  try {
    loading.value = true
    await addStoreIgnore(ruleForm.value)
    router.push({ path: "/listTenantPost" })
    loading.value = false
  } catch (e) {
    console.log(e)
    loading.value = false
  }
}
</script>

<template>
  <div v-loading="loading" style="height: 100%">
    <createTenantPost v-model="ruleForm" @success="handleCreateTenantClub"></createTenantPost>
  </div>
</template>

<style scoped>

</style>
